import React from "react";
import StoreFocus from "../../focus/StoreFocus";
import {
    FOCUS_LAYER__HOW_TO_PLAY,
    FOCUS_LAYER__MENU,
    FOCUS_LAYER_DEFAULT_FOCUS,
} from "../../common/const";
import focusable from "../../focus/Focusable";
import StoreHowToPlay from "../../store/StoreHowToPlay";
import StoreSounds from "../../store/StoreSounds";
import StoreApp from "../../store/StoreApp";

const CloseBtn = focusable(class CloseBtn extends React.Component {


    onCLick = () => {
        StoreSounds.playPls('click');

        if(!StoreApp.clicksEnabled)    return;

        StoreHowToPlay.hide();
        StoreFocus.setCurrentFocusLayer(FOCUS_LAYER__MENU, FOCUS_LAYER_DEFAULT_FOCUS.SAVED);
    }

    defaultFocused() {
        return true;
    }

    render() {
        //console.log('render CloseBtn');

        return (
            <div className={"btn focusable close " + (this.props.focused ? " focused" : "")} onClick={this.onCLick}></div>
        );

    }
})

export default CloseBtn;